import PlacementActions from '../../../support/PlacementActions';
import getNewVendorPlacement from '../../../support/helpers/getNewVendorPlacement';

import { Market } from '../../../types/shared/Market';
import {
  VendorList,
  VendorSummaryWithMarkets,
} from '../../../types/shared/Vendor';
import { PlacementByVendor } from '../../../types/shared/Placement';

/**
 * Used to place vendor to all or empty dates on a spot in a market.
 * Will only place the vendor only and if only the vendor sign up for that date.
 */
let placeVendor = (
  market: Market,
  vendors: VendorList,
  placement: PlacementByVendor,
  activeIndex: number,
  vendor: VendorSummaryWithMarkets,
  replacePlacedVendor: boolean,
) => {
  let position = activeIndex + 1;
  let placementByDate = getNewVendorPlacement(market, position, {
    vendors,
    placement,
  });
  let activeMarketID = market.id;
  let vendorMarkets = vendor.markets || {};
  let vendorDates = vendorMarkets[activeMarketID] || [];

  for (let date of vendorDates) {
    let placedVendor = placementByDate[date];
    if (placedVendor) {
      if (replacePlacedVendor === true) {
        PlacementActions.removeVendorPlacement(
          market,
          date,
          activeIndex,
          placedVendor,
        );
      } else {
        continue;
      }
    }
    PlacementActions.addVendorPlacement(market, date, activeIndex, vendor);
  }
};

type Args = [
  Market,
  VendorList,
  PlacementByVendor,
  number,
  VendorSummaryWithMarkets,
];

let placeVendorToAllDates = (...args: Args) => placeVendor(...args, true);

let placeVendorToEmptyDates = (...args: Args) => placeVendor(...args, false);

export { placeVendorToAllDates, placeVendorToEmptyDates };
